<template>
  <RightSheet style="width: 80vw;" v-model="dialogVisible" max-width="1920" class="air-condition-detail-dialog">
    <div class="dialog-wrapper">
      <!-- 标题栏 -->

      <template v-if="!showAlarmHistory">
        <div class="dialog-title">
          <div class="title-left">
            <v-btn icon variant="text" class="back-btn" @click="closeDialog">
              <v-icon>mdi-reply-outline</v-icon>
              返回
            </v-btn>
            <div class="title-text-group">
              <span class="title-text">空调详情</span>
              <!-- <v-tooltip location="bottom">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" size="small" color="#999" class="ml-2">mdi-information-outline</v-icon>
                </template>
                <span>排除故障可参考产品手册</span>
              </v-tooltip> -->
              <!-- <a :href="manualDownloadUrl" class="manual-link ml-4" target="_blank">空调产品手册下载</a> -->
            </div>
          </div>
          <div class="title-right">
            <v-btn :class="['alarm-history-btn', { 'active': showAlarmHistory }]" @click="toggleAlarmHistory">
              告警历史
            </v-btn>
            <v-btn icon variant="text" @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- 主内容区域 -->
        <v-card variant="flat" class="dialog-main gm-card">
          <!-- 路径显示 -->
          <div class="path-display">
            <span>{{ stationName }}</span>
            <span class="separator" v-if="currentELinkData.elink_name">&gt;</span>
            <span>{{ currentELinkData.elink_name }}</span>
            <span class="separator" v-if="currentEBlockData.eblock_name">&gt;</span>
            <span>{{ currentEBlockData.eblock_name }}</span>
          </div>

          <div class="content-scroll-container">
            <template v-if="aircondList.length > 0">
              <div class="aircond-row" v-for="aircond in aircondList" :key="aircond.aircond_idx">
                <!-- 左侧：空调状态图 -->
                <div class="left-section">
                  <div class="section-header" style="width: 300px; margin-bottom: 10px;">
                    <div class="header-left">
                      <div class="icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="14" viewBox="0 0 19 14" fill="none">
                          <path
                            d="M17.2713 0H1.7272C0.777204 0 0 0.784932 0 1.74412V5.66878H18.9982V1.74412C18.9982 0.784676 18.221 0 17.271 0H17.2713ZM16.1917 3.4885H14.4645C14.1189 3.4885 13.8169 3.18317 13.8169 2.83439C13.8169 2.48562 14.1192 2.18028 14.4645 2.18028H16.1917C16.5371 2.18028 16.8394 2.48562 16.8394 2.83439C16.8394 3.18317 16.5371 3.4885 16.1917 3.4885ZM0 7.84932C0 8.80877 0.777204 9.59344 1.7272 9.59344H17.2713C18.2213 9.59344 18.9985 8.80851 18.9985 7.84932V6.97726H0V7.84932ZM3.23835 10.9019C2.89301 10.9019 2.59068 11.207 2.59068 11.556V13.3004C2.59068 13.6492 2.89301 13.9545 3.23835 13.9545C3.58369 13.9545 3.88602 13.6492 3.88602 13.3004V11.556C3.88602 11.2073 3.58369 10.9019 3.23835 10.9019ZM6.26064 10.9019C5.9153 10.9019 5.61297 11.207 5.61297 11.556V13.3004C5.61297 13.6492 5.91505 13.9545 6.26064 13.9545C6.60623 13.9545 6.90831 13.6492 6.90831 13.3004V11.556C6.90831 11.2073 6.60598 10.9019 6.26064 10.9019ZM9.28318 10.9019C8.93784 10.9019 8.63551 11.207 8.63551 11.556V13.3004C8.63551 13.6492 8.93784 13.9545 9.28318 13.9545C9.62852 13.9545 9.93085 13.6492 9.93085 13.3004V11.556C9.93085 11.2073 9.62852 10.9019 9.28318 10.9019ZM12.3057 10.9019C11.9604 10.9019 11.6581 11.207 11.6581 11.556V13.3004C11.6581 13.6492 11.9604 13.9545 12.3057 13.9545C12.6511 13.9545 12.9534 13.6492 12.9534 13.3004V11.556C12.9534 11.2073 12.6513 10.9019 12.3057 10.9019ZM15.3283 10.9019C14.9829 10.9019 14.6806 11.207 14.6806 11.556V13.3004C14.6806 13.6492 14.9829 13.9545 15.3283 13.9545C15.6736 13.9545 15.9759 13.6492 15.9759 13.3004V11.556C15.9759 11.2073 15.6736 10.9019 15.3283 10.9019Z"
                            fill="url(#paint0_linear_1900_19730)" />
                          <defs>
                            <linearGradient id="paint0_linear_1900_19730" x1="9.49924" y1="0" x2="9.49924" y2="13.9545"
                              gradientUnits="userSpaceOnUse">
                              <stop stop-color="#DEF8B3" />
                              <stop offset="1" stop-color="#8DD3F5" />
                            </linearGradient>
                          </defs>
                        </svg>
                      </div>
                      <span class="section-label">空调状态:</span>
                    </div>
                    <span class="section-value">{{ aircond.aircond_idx + '#空调' }}</span>
                  </div>
                  <AirConditionState :state="aircond"></AirConditionState>
                </div>

                <!-- 右侧：空调参数 -->
                <div class="right-section">
                  <div class="section-header" style="width: 120px; margin-bottom: 10px;">
                    <div class="header-left">
                      <div class="icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="19" viewBox="0 0 21 19" fill="none">
                          <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M15 0.50082C14.9997 0.306685 15.1118 0.129918 15.2875 0.0474095C15.4632 -0.0350986 15.6708 -0.0084263 15.82 0.115821L19.94 3.54882C20.1018 3.68371 20.1616 3.90551 20.0897 4.10348C20.0179 4.30145 19.8296 4.43315 19.619 4.43282H0V2.43282H15V0.50082ZM20 16.4326V18.4326H0V16.4326H20ZM20 9.43262V11.4326H0V9.43262H20Z"
                            fill="#8DD3F5" />
                        </svg>
                      </div>
                      <span class="section-label">空调参数</span>
                    </div>
                  </div>

                  <div class="cards-container aircond-param-tabs-wrap">
                    <v-tabs
                      :model-value="acParamTab(aircond)"
                      @update:model-value="(v) => setAcParamTab(aircond, v)"
                      class="aircond-param-tabs"
                      color="#3a68ff"
                      density="comfortable"
                    >
                      <v-tab value="telemeter" class="aircond-param-tab">遥测</v-tab>
                      <v-tab value="telesignal" class="aircond-param-tab">遥信</v-tab>
                    </v-tabs>
                    <v-window
                      :model-value="acParamTab(aircond)"
                      @update:model-value="(v) => setAcParamTab(aircond, v)"
                      class="aircond-param-window"
                    >
                      <v-window-item value="telemeter">
                        <AirConditionDataCard label="遥测" hide-label class="striped-card">
                          <template #left>
                            <AirConditionDataItem label="空调厂家信息" :value="aircond.telemeter?.manufacturer || '--'" />
                            <AirConditionDataItem label="空调产品型号" :value="aircond.telemeter?.product_model || '--'" />
                            <AirConditionDataItem label="空调软件版本" :value="aircond.telemeter?.soft_version || '--'" />
                            <AirConditionDataItem label="空调机组状态"
                              :value="getStatusDesc(WorkStatus, aircond.telemeter?.work_state)" />
                            <AirConditionDataItem label="开关机"
                              :value="getStatusDesc(SwitchStatus, aircond.telemeter?.on_off)"
                              :status="getStatusDesc(StopStatus, aircond.telemeter?.on_off)" />
                            <AirConditionDataItem label="柜内温度(℃)" :value="aircond.telemeter?.cabinet_in_temp" />
                            <AirConditionDataItem label="柜外温度(℃)" :value="aircond.telemeter?.cabinet_out_temp" />
                            <AirConditionDataItem label="湿度值(%)" :value="aircond.telemeter?.humity" />
                            <AirConditionDataItem label="交流电压(V)" :value="aircond.telemeter?.ac_voltage" />
                            <AirConditionDataItem label="直流电压(V)" :value="aircond.telemeter?.dc_voltage" />
                            <AirConditionDataItem label="蒸发器温度(℃)" :value="aircond.telemeter?.evaporator_temp" />
                            <AirConditionDataItem label="冷凝器温度(℃)" :value="aircond.telemeter?.condenser_temp" />
                            <AirConditionDataItem label="内风机转速(rpm)" :value="aircond.telemeter?.fan_in_speed" />
                            <AirConditionDataItem label="外风机转速(rpm)" :value="aircond.telemeter?.fan_out_speed" />
                          </template>
                          <template #right>
                            <AirConditionDataItem label="制冷开启温度(℃)" :value="aircond.telemeter?.cool_start_temp" />
                            <AirConditionDataItem label="制冷停止温度(℃)" :value="aircond.telemeter?.cool_stop_temp" />
                            <AirConditionDataItem label="制热开启温度(℃)" :value="aircond.telemeter?.heat_start_temp" />
                            <AirConditionDataItem label="制热停止温度(℃)" :value="aircond.telemeter?.heat_stop_temp" />
                            <AirConditionDataItem label="柜内高温告警点(℃)" :value="aircond.telemeter?.cabin_in_temp_high" />
                            <AirConditionDataItem label="柜内低温告警点(℃)" :value="aircond.telemeter?.cabin_in_temp_low" />
                            <AirConditionDataItem label="冷凝器温度高温保护点(℃)" :value="aircond.telemeter?.conden_protect_high" />
                            <AirConditionDataItem label="蒸发器温度冻结保护点(℃)" :value="aircond.telemeter?.evap_protect_low" />
                            <AirConditionDataItem label="除湿开启湿度(%)" :value="aircond.telemeter?.dehumidify_start" />
                            <AirConditionDataItem label="除湿停止湿度(%)" :value="aircond.telemeter?.dehumidify_stop" />
                            <AirConditionDataItem label="湿度告警限制(%)" :value="aircond.telemeter?.humidify_alarm_limit" />
                            <AirConditionDataItem label="湿度校正值(-6~6)" :value="aircond.telemeter?.humidify_calib_value" />
                            <AirConditionDataItem label="除湿开启温度(℃)" :value="aircond.telemeter?.dehumidify_start_temp" />
                            <AirConditionDataItem label="除湿停止温度(℃)" :value="aircond.telemeter?.dehumidify_stop_temp" />
                          </template>
                        </AirConditionDataCard>
                      </v-window-item>
                      <v-window-item value="telesignal">
                        <AirConditionDataCard label="遥信" hide-label class="striped-card">
                          <template #left>
                            <AirConditionDataItem label="制冷状态"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.cooling_state)" />
                            <AirConditionDataItem label="加热状态"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.heating_state)" />
                            <AirConditionDataItem label="内风机状态"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.fan_in_state)" />
                            <AirConditionDataItem label="外风机状态"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.fan_out_state)" />
                            <AirConditionDataItem label="应急风机状态"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.fan_spare_state)" />
                            <AirConditionDataItem label="预留开关量1输出"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.reserved_onoff_out1)" />
                            <AirConditionDataItem label="预留开关量2输出"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.reserved_onoff_out2)" />
                            <AirConditionDataItem label="监控关机"
                              :value="getStatusDesc({ 0: '运行', 1: '关机' }, aircond.telesignal?.monitor_shutdown)" />
                            <AirConditionDataItem label="除湿状态"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.dehumidify_state)" />
                            <AirConditionDataItem label="压缩机状态"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.compressor_state)" />
                            <AirConditionDataItem label="加热器状态"
                              :value="getStatusDesc(StopStart, aircond.telesignal?.heater_state)" />
                            <AirConditionDataItem label="柜内传感器故障"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.cabin_in_sensor_fault)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.cabin_in_sensor_fault)" />
                            <AirConditionDataItem label="柜外温度传感器故障"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.cabin_out_temp_sensor_fault)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.cabin_out_temp_sensor_fault)" />
                            <AirConditionDataItem label="蒸发器温度传感器故障"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.evap_temp_sensor_fault)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.evap_temp_sensor_fault)" />
                            <AirConditionDataItem label="冷凝器温度传感器故障"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.conden_temp_sensor_fault)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.conden_temp_sensor_fault)" />
                            <AirConditionDataItem label="湿度传感器故障"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.hum_sensor_fault)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.hum_sensor_fault)" />
                          </template>
                          <template #right>
                            <AirConditionDataItem label="湿度过高告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.hum_high_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.hum_high_alarm)" />
                            <AirConditionDataItem label="内风机告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.fan_in_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.fan_in_alarm)" />
                            <AirConditionDataItem label="外风机告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.fan_out_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.fan_out_alarm)" />
                            <AirConditionDataItem label="冷凝器高压告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.conden_high_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.conden_high_alarm)" />
                            <AirConditionDataItem label="蒸发器冻结告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.evap_frozen_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.evap_frozen_alarm)" />
                            <AirConditionDataItem label="制冷告警（压缩机&制冷系统告警）"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.cooling_alarm)" labelWidth="120px"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.cooling_alarm)" />
                            <AirConditionDataItem label="高温告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.temp_high_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.temp_high_alarm)" />
                            <AirConditionDataItem label="低温告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.temp_low_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.temp_low_alarm)" />
                            <AirConditionDataItem label="加热器告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.heater_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.heater_alarm)" />
                            <AirConditionDataItem label="过电压告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.over_voltage_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.over_voltage_alarm)" />
                            <AirConditionDataItem label="欠电压告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.under_voltage_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.under_voltage_alarm)" />
                            <AirConditionDataItem label="高低电压告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.high_low_voltage_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.high_low_voltage_alarm)" />
                            <AirConditionDataItem label="高低压力告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.high_low_press_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.high_low_press_alarm)" />
                            <AirConditionDataItem label="高低温度告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.high_low_temp_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.high_low_temp_alarm)" />
                            <AirConditionDataItem label="空调门禁告警"
                              :value="getStatusDesc(Alarms, aircond.telesignal?.door_alarm)"
                              :status="getStatusDesc(AlarmStatus, aircond.telesignal?.door_alarm)" />
                          </template>
                        </AirConditionDataCard>
                      </v-window-item>
                    </v-window>
                  </div>
                </div>
              </div>
            </template>
            <div v-else class="no-data">暂无数据</div>
          </div>
        </v-card>
      </template>

      <!-- 告警历史抽屉遮罩 -->
      <!-- <div class="drawer-overlay" v-if="showAlarmHistory" @click="showAlarmHistory = false"></div> -->

      <!-- 告警历史 -->
      <div v-else>
        <div class="dialog-title">
          <div class="title-left">
            <v-btn icon variant="text" class="back-btn" @click="showAlarmHistory = false" v-if="showBackBtn">
              <v-icon>mdi-reply-outline</v-icon>
              返回
            </v-btn>
            <div class="title-text-group">
              <span class="title-text">告警历史</span>
            </div>
          </div>
          <div class="title-right">
            <v-btn icon variant="text" density="compact" @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <v-card variant="flat" :loading="alarmLoading" class="dialog-main gm-card">
          <!-- 筛选栏 -->
          <div class="filter-bar">
            <!-- <div class="filter-item">
              <label class="filter-label date-label">请选择日期</label>
              <v-menu v-model="showAlarmDateMenu" :close-on-content-click="false" location="bottom">
                <template #activator="{ props }">
                  <v-text-field v-model="alarmDateRangeText" type="text" placeholder="开始时间 至 结束时间" variant="outlined"
                    density="compact" class="filter-date-picker" readonly hide-details v-bind="props"
                    @click:clear="handleAlarmDateClear">
                    <template #append-inner>
                      <v-icon>mdi-calendar-month</v-icon>
                    </template>
                  </v-text-field>
                </template>
                <v-card class="filter-time-picker">
                  <v-date-picker v-model="alarmDatePickerRange" multiple :min="alarmMinDate" :max="alarmMaxDate" />
                  <v-card-actions>
                    <v-spacer />
                    <v-btn variant="text" @click="handleAlarmDateCancel">取消</v-btn>
                    <v-btn style="color: #3a68ff;" @click="handleAlarmDateConfirm">确定</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </div> -->
            <div class="filter-item">
              <label class="filter-label">开始时间</label>
              <v-date-input v-model="alarmDateRangeStart" type="datetime" variant="outlined" density="compact"
                class="filter-input" clearable hide-details format="YYYY-MM-DD HH:mm:ss" />
            </div>
            <div class="filter-item">
              <label class="filter-label">结束时间</label>
              <v-date-input v-model="alarmDateRangeEnd" type="datetime" variant="outlined" density="compact"
                class="filter-input" clearable hide-details format="YYYY-MM-DD HH:mm:ss" />
            </div>
            <div class="filter-item">
              <label class="filter-label">故障名称</label>
              <v-text-field v-model="alarmFilterDescription" placeholder="请输入故障名称" variant="outlined" density="compact"
                class="filter-input" clearable hide-details />
            </div>
            <div class="filter-actions">
              <v-btn color="primary" class="query-btn" @click="handleAlarmSearch">
                <v-icon start>mdi-magnify</v-icon>
                查询
              </v-btn>
            </div>
          </div>

          <!-- 告警列表表格 -->
          <div class="alarm-table-container">
            <div class="table-wrapper">
              <v-data-table :headers="alarmTableHeaders" :items="alarmList" :items-per-page="alarmPagination.pageSize"
                :page="alarmPagination.current" class="alarm-table gm-table" item-value="id" hide-default-footer
                no-data-text="暂无数据">
              </v-data-table>
            </div>
          </div>

          <TablePagination v-model="alarmPagination.current" :total="alarmPagination.total"
            :page-size="alarmPagination.pageSize" @change="() => fetchAlarmHistory()" />
        </v-card>
      </div>
    </div>
  </RightSheet>
</template>

<script setup>
import { ref, computed, watch, onUnmounted, reactive } from 'vue'
import { ws_req } from '@/ws/wss-request'
import { useStationContext } from '../../composables/useStationContext'
import AirConditionState from './AirConditionState.vue'
import AirConditionDataItem from './AirConditionDataItem.vue'
import AirConditionDataCard from './AirConditionDataCard.vue'
import dayjs from 'dayjs'
import { getAirconditionAlarmList } from '@/api/production/alarm'
import RightSheet from '@/components/RightSheet/index.vue'
import TablePagination from '@/components/TablePagination/index.vue'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  stationId: [String, Number],
  elinkUuid: String,
  eblockUuid: String,
  openAlarmHistory: {
    type: Boolean,
    default: false
  },
  showBackBtn: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:modelValue', 'close'])

const dialogVisible = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
})

const { stationName } = useStationContext()

// Manual download URL - use dev URL or production URL based on environment
const manualDownloadUrl = computed(() => {
  // Check if we're in development environment
  return `/product_file/heidun.pdf`
})

// Data
const currentELinkData = ref({})
const currentEBlockData = ref({})
const aircondList = ref([])
/** 每台空调参数区「遥测 / 遥信」Tab，按 aircond_idx 区分 */
const acParamTabs = reactive({})
function acParamTab(aircond) {
  const v = acParamTabs[aircond.aircond_idx]
  return v === 'telesignal' || v === 'telemeter' ? v : 'telemeter'
}
function setAcParamTab(aircond, v) {
  acParamTabs[aircond.aircond_idx] = v
}
let timer = null

// Status Maps
const Alarms = {
  0: '正常',
  1: '告警',
}

const StopStart = {
  0: '停止',
  1: '开启',
}

const AlarmStatus = {
  0: 'success',
  1: 'error',
}

const StopStatus = {
  0: 'error',
  1: 'success',
}

/* 空调机组状态 */
const WorkStatus = {
  0: '关机',
  1: '送风',
  2: '制冷',
  3: '加热',
  4: '除湿',
}
/* 开关机 */
const SwitchStatus = {
  0: '关机',
  1: '开机',
}

function getStatusDesc(statusMap, status) {
  if (status === undefined || status === null) return '--'
  return statusMap[status] || '--'
}

const fetchData = async (recurs = false) => {
  if (!props.stationId) return

  try {
    const r = await ws_req.request('aircondition', {
      stationId: props.stationId
    })

    if (Array.isArray(r)) {
      const currentELink = r.find(item => item.uuid === props.elinkUuid)
      if (currentELink) {
        currentELinkData.value = currentELink

        if (props.eblockUuid) {
          // 查看 eBlock 的空调数据
          const currentEBlock = (currentELink.eblockList || []).find(item => item.uuid === props.eblockUuid)
          if (currentEBlock) {
            currentEBlockData.value = currentEBlock
            aircondList.value = currentEBlock.aircond || []
          }
        } else {
          // 查看 eLink 的空调数据
          currentEBlockData.value = {}
          aircondList.value = currentELink.aircondition?.aircond || []
        }
      }
    }
  } catch (e) {
    console.error('Fetch Aircondition Detail Failed', e)
  }

  if (recurs && dialogVisible.value) {
    timer = setTimeout(() => {
      fetchData(true)
    }, 5000)
  }
}

watch(dialogVisible, (newVal) => {
  if (newVal) {
    fetchData(true)

    // If openAlarmHistory prop is true, automatically show alarm history
    if (props.openAlarmHistory) {
      toggleAlarmHistory()
    }
  } else {
    clearTimeout(timer)
    // Reset alarm history view when closing
    showAlarmHistory.value = false
  }
})

onUnmounted(() => {
  clearTimeout(timer)
})

const closeDialog = () => {
  dialogVisible.value = false
  emit('close')
}

// Alarm History State
const showAlarmHistory = ref(false)
const alarmList = ref([])
const alarmLoading = ref(false)
const alarmPagination = ref({
  current: 1,
  pageSize: 10,
  total: 0
})
const alarmJumpPage = ref(1)

// Alarm filter states
const alarmFilterDescription = ref('')
const alarmDateRangeText = ref('')
const showAlarmDateMenu = ref(false)
const alarmDatePickerRange = ref([])
const alarmDateRangeStart = ref(dayjs().startOf('day').toDate())
const alarmDateRangeEnd = ref(dayjs().endOf('day').toDate())
const alarmMinDate = ref('')
const alarmMaxDate = ref('')
const prevAlarmDateCount = ref(0)

// Page size options
const pageSizeItems = [
  { title: '10 条/页', value: 10 },
  { title: '20 条/页', value: 20 },
  { title: '50 条/页', value: 50 },
  { title: '100 条/页', value: 100 }
]

// Alarm table headers
const alarmTableHeaders = [
  { title: '序号', key: 'index', sortable: false },
  { title: '空调编号', key: 'airconditionIndex', sortable: false },
  { title: '告警开始时间', key: 'startTime', sortable: false },
  { title: '告警结束时间', key: 'endTime', sortable: false },
  { title: '故障key', key: 'alarmWindowKey', sortable: false },
  { title: '故障名称', key: 'alarmWindowValue', sortable: false }
]

// Toggle alarm history view
const toggleAlarmHistory = () => {
  showAlarmHistory.value = !showAlarmHistory.value

  if (showAlarmHistory.value) {
    // Initialize alarm history date range
    alarmDateRangeStart.value = dayjs().startOf('day').toDate()
    alarmDateRangeEnd.value = dayjs().endOf('day').toDate()

    // Fetch alarm history
    fetchAlarmHistory()
  }
}

// Format date for display
const formatDateToString = (date) => {
  if (!date) return ''
  if (typeof date === 'string') {
    return date.split('T')[0]
  }
  if (date instanceof Date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
  return String(date)
}

// Watch alarm date picker changes
// watch(alarmDatePickerRange, (newVal) => {
//   if (!Array.isArray(newVal)) return

//   const formattedDates = newVal.map(formatDateToString)
//   const currentCount = formattedDates.length

//   if (prevAlarmDateCount.value === 2 && currentCount >= 3) {
//     const newSelectedDate = formattedDates[formattedDates.length - 1]
//     alarmDatePickerRange.value = [newSelectedDate]
//     alarmDateRangeStart.value = `${newSelectedDate} 00:00:00`
//     alarmDateRangeEnd.value = `${newSelectedDate} 23:59:59`
//     alarmDateRangeText.value = newSelectedDate
//     prevAlarmDateCount.value = 1
//     return
//   }

//   prevAlarmDateCount.value = currentCount

//   if (formattedDates.length > 2) {
//     const limitedDates = formattedDates.slice(0, 2).sort()
//     alarmDatePickerRange.value = limitedDates
//     const startDate = limitedDates[0]
//     const endDate = limitedDates[1]
//     alarmDateRangeStart.value = `${startDate} 00:00:00`
//     alarmDateRangeEnd.value = `${endDate} 23:59:59`
//     alarmDateRangeText.value = `${startDate} 至 ${endDate}`
//   } else if (formattedDates.length === 2) {
//     const sortedDates = [...formattedDates].sort()
//     const startDate = sortedDates[0]
//     const endDate = sortedDates[1]

//     if (formattedDates[0] !== startDate || formattedDates[1] !== endDate) {
//       alarmDatePickerRange.value = sortedDates
//     }

//     alarmDateRangeStart.value = `${startDate} 00:00:00`
//     alarmDateRangeEnd.value = `${endDate} 23:59:59`
//     alarmDateRangeText.value = `${startDate} 至 ${endDate}`
//   } else if (formattedDates.length === 1) {
//     const selectedDate = formattedDates[0]
//     alarmDateRangeStart.value = `${selectedDate} 00:00:00`
//     alarmDateRangeEnd.value = `${selectedDate} 23:59:59`
//     alarmDateRangeText.value = selectedDate
//   } else if (formattedDates.length === 0) {
//     alarmDateRangeStart.value = ''
//     alarmDateRangeEnd.value = ''
//     alarmDateRangeText.value = ''
//   }
// })

// Fetch alarm history
const fetchAlarmHistory = async () => {
  alarmLoading.value = true
  try {
    const uuid = props.eblockUuid || props.elinkUuid
    if (!uuid) {
      alarmLoading.value = false
      return
    }

    const params = {
      uuid,
      pageNum: alarmPagination.value.current,
      pageSize: alarmPagination.value.pageSize
    }

    if (alarmDateRangeStart.value) {
      params.startTime = dayjs(alarmDateRangeStart.value).format('YYYY-MM-DD HH:mm:ss')
    }
    if (alarmDateRangeEnd.value) {
      params.endTime = dayjs(alarmDateRangeEnd.value).format('YYYY-MM-DD HH:mm:ss')
    }
    if (alarmFilterDescription.value) {
      params.alarmWindowValue = alarmFilterDescription.value
    }



    const result = await getAirconditionAlarmList(params)

    alarmList.value = (result.rows || []).map((item, index) => ({
      ...item,
      index: (alarmPagination.value.current - 1) * alarmPagination.value.pageSize + index + 1,
      airconditionIndex: item.airconditionIndex ? `${item.airconditionIndex}#空调` : ''
    }))
    alarmPagination.value.total = result.total || 0
  } catch (error) {
    console.error('获取告警历史失败:', error)
    alarmList.value = []
    alarmPagination.value.total = 0
  } finally {
    alarmLoading.value = false
  }
}

// Alarm date handlers
const handleAlarmDateConfirm = () => {
  showAlarmDateMenu.value = false
}

const handleAlarmDateCancel = () => {
  showAlarmDateMenu.value = false
}

const handleAlarmDateClear = () => {
  alarmDatePickerRange.value = []
  alarmDateRangeStart.value = ''
  alarmDateRangeEnd.value = ''
  alarmDateRangeText.value = ''
  prevAlarmDateCount.value = 0
}

// Alarm search handler
const handleAlarmSearch = () => {
  alarmPagination.value.current = 1
  alarmJumpPage.value = 1
  fetchAlarmHistory()
}

// Alarm pagination handlers
const handleAlarmSizeChange = (size) => {
  alarmPagination.value.pageSize = size
  alarmPagination.value.current = 1
  alarmJumpPage.value = 1
  fetchAlarmHistory()
}

const handleAlarmPageChange = (page) => {
  alarmPagination.value.current = page
  alarmJumpPage.value = page
  fetchAlarmHistory()
}

const handleAlarmJumpToPage = () => {
  const totalPages = Math.ceil(alarmPagination.value.total / alarmPagination.value.pageSize)
  if (alarmJumpPage.value >= 1 && alarmJumpPage.value <= totalPages) {
    alarmPagination.value.current = alarmJumpPage.value
    fetchAlarmHistory()
  } else {
    alarmJumpPage.value = alarmPagination.value.current
  }
}

// Handle alarm row click - switch to air conditioning details view
const handleAlarmRowClick = (event, { item }) => {
  // Close alarm history view and show air conditioning details
  showAlarmHistory.value = false

  // Scroll to the specific air conditioner if airconditionIndex is available
  // The aircondList is already filtered by elink/eblock UUID, so we just need to scroll
  if (item.airconditionIndex) {
    // Extract the index number from "1#空调" format
    const match = item.airconditionIndex.match(/^(\d+)#/)
    if (match) {
      const aircondIdx = parseInt(match[1])
      // Wait for the view to render, then scroll to the air conditioner
      setTimeout(() => {
        const element = document.querySelector(`.aircond-row:nth-child(${aircondIdx})`)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }, 100)
    }
  }
}

</script>

<style scoped lang="scss">
.dialog-wrapper {
  position: relative;
  width: 100%;
  height: 100vh;
  padding: 20px 24px 0;
  background-color: #fff !important;
  background: url('@/assets/images/station-monitor/detail-dialog/detail-bg.svg') no-repeat center center;
  background-size: cover;
  border-radius: 30px 30px 0 0 !important;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* Prevent drawer from sticking out */
}

.dialog-title {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 20px;
  color: rgba(46, 46, 46, 1);
  font-weight: normal;
  margin-bottom: 20px;
  padding-left: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  flex-shrink: 0;
  /* Ensure title doesn't shrink */
}

.title-left {
  display: flex;
  align-items: center;
}

.title-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.alarm-history-btn {
  width: 83px !important;
  height: 32px !important;
  min-height: 32px !important;
  max-height: 32px !important;
  border-radius: 12px !important;
  background: #fff !important;
  color: #2E2E2E !important;
  border: 1px solid #C0CFDA !important;
  font-family: "HarmonyOS Sans SC", sans-serif;
  font-size: 14px;
  font-weight: 400;
  text-transform: none !important;
  padding: 0 !important;
  box-shadow: none !important;

  &.active {
    background: #3A68FF !important;
    color: #fff !important;
    border-color: #3A68FF !important;
  }

  &:hover {
    opacity: 0.9;
  }
}

.back-btn {
  width: 98px;
  height: 40px;
  border-radius: 12px;
  border: 1px solid #C0CFDA;
  margin-right: 20px;
  font-weight: bold;
}

.title-text-group {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  color: #333;
}

.title-text {
  font-size: 20px;
  font-weight: 500;
}

.manual-link {
  font-size: 14px;
  color: #2F51FF;
  text-decoration: underline;
  cursor: pointer;
}

.dialog-main {
  height: calc(100vh - 96px);
  // background: rgba(246, 251, 255, 1);
  border-radius: 30px;
  padding: 30px !important;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.path-display {
  font-size: 16px;
  color: #000;
  font-weight: 500;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.separator {}

.content-scroll-container {
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding-right: 10px;
}

.aircond-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 20px 24px;
  margin-bottom: 32px;
  border-bottom: 1px dashed #ccc;
  padding-bottom: 24px;

  &:last-child {
    border-bottom: none;
  }
}

.left-section {
  flex: 0 1 750px;
  width: min(750px, 100%);
  max-width: 100%;
  min-width: 0;
}

.right-section {
  flex: 1 1 400px;
  min-width: min(100%, 360px);
  display: flex;
  flex-direction: column;
}

.cards-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-width: 0;
}

.aircond-param-tabs-wrap {
  gap: 0;
}

.aircond-param-tabs {
  flex-shrink: 0;
  min-height: 40px;
  border-radius: 8px 8px 0 0;
  background: rgba(239, 244, 251, 0.7);

  :deep(.v-tab) {
    font-family: 'HarmonyOS Sans SC', sans-serif;
    font-size: 15px;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0;
  }
}

.aircond-param-window {
  min-width: 0;

  :deep(.v-window__container) {
    min-height: 0;
  }

  :deep(.def-data-card--no-label) {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}

.no-data {
  text-align: center;
  padding: 50px;
  color: #999;
}

/* Section Header Styles */
.section-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: transparent;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon-wrapper {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.section-label {
  color: #000;
  font-family: "HarmonyOS Sans SC";
  font-size: 14px;
  font-weight: 400;
}

.section-value {
  font-family: 'HarmonyOS Sans SC', sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.60);
  font-weight: 500;
  margin-left: 10px;
}

/* Zebra Striping for cards（流式网格内按行斑马纹） */
:deep(.striped-card) {
  border: solid 1px #F4F7FC;
  background-color: #fff;
  border-radius: 4px;

  .card-flow-grid .def-data-item:nth-child(even) {
    background-color: rgba(239, 244, 251, 0.70) !important;
  }

  .card-flow-grid .def-data-item:nth-child(odd) {
    background-color: #fff !important;
  }
}

/* Alarm History Styles */
.alarm-history-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 0;
  overflow: hidden;
  padding: 20px;
  /* Add padding inside drawer */
}

.filter-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  padding: 0 0 16px 0;
  /* Adjusted padding */
  background: transparent;
  flex-shrink: 0;
  flex-wrap: wrap;
  /* Allow wrapping for narrow width */
  overflow-x: auto;
  min-height: 72px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  margin-right: 24px;
  height: 40px;
  margin-bottom: 10px;
  /* Add margin for wrapping */
}

.filter-label {
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #2e2e2e;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}

.filter-label.date-label {
  color: #2E2E2E;
  font-family: "HarmonyOS Sans SC", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.filter-date-picker {
  width: 280px;

  :deep(.v-field) {
    min-height: 40px !important;
    height: 40px !important;
    max-height: 40px !important;
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    display: flex;
    align-items: center;
    margin: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  :deep(.v-field__input) {
    padding: 8px 0px 8px 16px;
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    color: #2E2E2E;
    min-height: auto;
    display: flex;
    align-items: center;
  }

  :deep(.v-field__outline) {
    display: none;
  }

  :deep(input::placeholder) {
    color: rgba(46, 46, 46, 0.5);
    font-weight: 400;
    font-family: "HarmonyOS Sans SC", sans-serif;
  }
}

.filter-time-picker {
  :deep(.v-picker-title) {
    display: none;
  }

  :deep(.v-date-picker-header) {
    display: none;
  }

  :deep(.v-date-picker-header__content) {
    color: #2E2E2E;
    font-family: "HarmonyOS Sans SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
}

.filter-input {
  width: 200px;

  :deep(.v-field) {
    min-height: 40px !important;
    height: 40px !important;
    max-height: 40px !important;
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    display: flex;
    align-items: center;
    margin: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }

  :deep(.v-field__input) {
    padding: 8px 16px;
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    color: #2E2E2E;
    min-height: auto;
    display: flex;
    align-items: center;
  }

  // :deep(.v-field__outline) {
  //   display: none;
  // }

  :deep(input::placeholder) {
    color: rgba(46, 46, 46, 0.5);
    font-weight: 400;
    font-family: "HarmonyOS Sans SC", sans-serif;
  }
}

.filter-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: 16px;
  flex-shrink: 0;
  height: 40px;
  margin-bottom: 10px;
}

.query-btn {
  width: 98px;
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  border-radius: 12px !important;
  font-family: "HarmonyOS Sans SC", sans-serif;
  font-size: 14px;
  font-weight: 400;
  background: #3a68ff !important;
  color: #fff !important;
  text-transform: none !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(.v-btn__prepend) {
    margin-inline-end: 6px;
  }

  :deep(.v-icon) {
    font-size: 13px;
    width: 13px;
    height: 13px;
  }

  &:hover {
    background: #3a68ff !important;
    opacity: 0.9;
  }
}

.alarm-table-container {
  flex: 1;
  min-height: 0;
  background: transparent;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 0;
}

.alarm-table {
  width: 100%;
  flex: 1;
  min-height: 0;

  :deep(.v-data-table) {
    background: transparent;
  }

  :deep(.v-data-table__thead) {
    th {
      background: transparent !important;
      color: #96a5b8;
      font-family: "HarmonyOS Sans SC", sans-serif;
      font-size: 13px;
      font-weight: 400;
      font-style: normal;
      padding: 12px 0;
      border-bottom: none;
      line-height: 16px;
      text-align: left;
      white-space: nowrap;
      /* Prevent wrap in table header */

      .v-data-table-header__content {
        color: #96a5b8;
        font-family: "HarmonyOS Sans SC", sans-serif;
        font-size: 13px;
        font-weight: 400;
        font-style: normal;
        line-height: 16px;
      }
    }
  }

  :deep(.v-data-table__tbody) {
    tr {
      cursor: pointer;

      td {
        color: #444a6d;
        font-family: 'PingFang SC', sans-serif;
        font-size: 14px;
        font-weight: 400;
        padding: 12px 0;
        border-bottom: none;
        line-height: 1.5;
        white-space: nowrap;
        /* Prevent wrap in table cells */
      }
    }

    tr:nth-child(even) {
      background: #edf2f6 !important;
    }

    tr:nth-child(odd) {
      background: transparent !important;
    }

    tr:hover {
      background: #d6e4f0 !important;
    }
  }

  :deep(.v-data-table__empty-wrapper) {
    min-height: 200px;
  }
}

.pagination-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 0px;
  background: transparent;
  flex-shrink: 0;
  border-top: 1px solid #f0f0f0;
  flex-wrap: wrap;
  /* Allow wrap for pagination */
  gap: 10px;
}

.pagination-info {
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.6);
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
}

.page-size-select {
  width: 112px;
  flex-shrink: 0;

  :deep(.v-field) {
    background: #fff !important;
    border: 1px solid #dcdcdc !important;
    border-radius: 3px !important;
    min-height: auto !important;
    height: auto !important;
    padding: 5px 8px !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center !important;
  }

  :deep(.v-field__input) {
    padding: 0 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: rgba(0, 0, 0, 0.9) !important;
    min-height: auto !important;
    height: 22px !important;
    line-height: 22px !important;
    display: flex !important;
    align-items: center !important;
  }

  :deep(.v-select__selection) {
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: rgba(0, 0, 0, 0.9) !important;
    line-height: 22px !important;
    margin: 0 !important;
  }

  // :deep(.v-field__outline) {
  //   display: none !important;
  // }

  :deep(.v-field__append-inner .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: #2E2E2E !important;
    opacity: 0.22;
  }
}

.custom-pagination {
  flex-shrink: 0;

  :deep(.v-pagination__list) {
    align-items: center;
    gap: 8px !important;
    margin: 0 !important;
  }

  :deep(.v-pagination__item) {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 3px !important;
    margin: 0 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 22px !important;
    border: 1px solid #dcdcdc !important;
    background: #fff !important;
    color: rgba(0, 0, 0, 0.9) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    transition: none !important;
    box-shadow: none !important;
    text-align: center !important;

    &.v-pagination__item--is-active {
      background: #3a68ff !important;
      color: rgba(255, 255, 255, 0.9) !important;
      border-color: #3a68ff !important;
      box-shadow: none !important;
    }
  }

  :deep(.v-pagination__prev),
  :deep(.v-pagination__next) {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 3px !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
  }

  :deep(.v-pagination__prev .v-icon),
  :deep(.v-pagination__next .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: rgba(0, 0, 0, 1) !important;
  }
}

.jump-to-page {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  background: #e3e3e3;
  padding: 2px 8px;
  border-radius: 3px;
  line-height: 22px;
  height: 34px;
  width: 160px;
  flex-shrink: 0;

  span {
    white-space: nowrap;
    line-height: 22px;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }

  .jump-input {
    flex: 1 0 0;
    min-width: 0;

    :deep(.v-field) {
      background: #fff !important;
      border: 1px solid #dcdcdc !important;
      border-radius: 3px !important;
      min-height: auto !important;
      height: auto !important;
      padding: 2px 8px !important;
      margin: 0 !important;
      box-shadow: none !important;
    }

    :deep(.v-field__input) {
      padding: 0 !important;
      text-align: center !important;
      font-family: 'PingFang SC', sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: rgba(0, 0, 0, 0.9) !important;
      min-height: auto !important;
      height: 22px !important;
      line-height: 22px !important;
    }

    // :deep(.v-field__outline) {
    //   display: none !important;
    // }

    :deep(input) {
      text-align: center !important;
      padding: 0 !important;
      margin: 0 !important;
    }
  }
}

:deep(.mdi-menu-down) {
  font-size: 16px !important;
  width: 16px !important;
  height: 16px !important;
  color: #2E2E2E !important;
  opacity: 0.22;
}

/* New Drawer Styles */
.drawer-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(109deg, rgba(1, 1, 1, 0.5) 1.53%, rgba(1, 1, 1, 0.5) 98.28%) !important;
  opacity: 1 !important;
  backdrop-filter: blur(5px) !important;
  z-index: 99;
}

.alarm-drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 1000px;
  background: #fff;
  z-index: 100;
  transform: translateX(100%);
  transition: transform 0.3s ease;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  border-top-right-radius: 30px;
  /* Match dialog wrapper */

  &.drawer-open {
    transform: translateX(0);
  }
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #eee;
  flex-shrink: 0;

  .drawer-title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
  }
}
</style>
